import { useNavigate } from "react-router-dom";
import { config } from "../Environment";
import { useEffectOnce } from "../hooks/useEffectOnce";
import useRetryFetch from "../hooks/useRetryFetch";
import { useContext } from "react";
import { useTranslation } from "react-i18next";
import LoggerContext from "../context/LoggerProvider";
import useAuth from "../hooks/useAuth";
import loadingImage from "../images/loading.gif";

function Home() {
  const navigate = useNavigate();
  const retryFetch = useRetryFetch();
  const { auth } = useAuth();
  const { Logger } = useContext(LoggerContext);
  const { t } = useTranslation();

  useEffectOnce(() => {
    console.log(`Home.jsx useEffectOnce`);
    if (auth?.email) {
      navigate("/portal");
    } else {
      // navigate to "Welcome to ClaryNext" prescription in run mode

      const startWelcome = async () => {
        // get welcome prescription
        let welcomeResponse = await fetch(config.API_BASE + `/api/welcome`);
        let welcome = await welcomeResponse.json();

        if (welcome === null) {
          console.log("Welcome activity not defined, redirecting to setup");
          navigate("/setup");
          return;
        }

        // create a new process and start it
        let newResponse = await retryFetch(
          config.API_BASE + `/api/processes/${welcome._id}`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            credentials: "include",
            body: JSON.stringify({
              email: auth.email,
            }),
          }
        );
        let result = await newResponse.json();
        Logger.debug(result);

        // TODO: refactor all the different ways to start a process into a library function we can call with options
        sessionStorage.setItem("prescriptionID", welcome._id);
        sessionStorage.setItem(
          "prescriptionHistoryID",
          result.prescriptionHistoryID
        );
        sessionStorage.setItem("runProcessID", result.processId);
        sessionStorage.removeItem("nextActivity");
        sessionStorage.setItem("isWelcome", "true");
        navigate("/preview");
      };

      startWelcome();
    }
  }, []);

  return (
    <div className="loadingcenter">
      <img src={loadingImage} alt={t("loading")} title={t("loading")} width="32" height="32" />
    </div>
  );
}

export default Home;
